import { render } from "./OverlayPanel.vue?vue&type=template&id=0b3ef180"
import script from "./OverlayPanel.vue?vue&type=script&lang=js"
export * from "./OverlayPanel.vue?vue&type=script&lang=js"

import "./OverlayPanel.vue?vue&type=style&index=0&id=0b3ef180&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__